import { RouteHandler } from 'wee-routes';
import $events from 'wee-events';
import $ from 'wee-dom';
import $location from 'wee-location';
import $screen from 'wee-screen';
import TabbedContent from '../tabbed-content';

export default new RouteHandler({
    init() {
        const location = $location.uri();
        const map = {
            ArrowLeft: 'prev',
            ArrowRight: 'next',
            Escape: 'close',
        }

        $(':tabbed').each((el) => {
            const $el = $(el);
            const tabs = new TabbedContent(el, $el.data('scroll'));

            if ($el.data('locations')) {
                $screen.map({
                    min: 3,
                    callback: () => {
                        tabs.$buttonsWrapper.after(tabs.$container);
                    },
                });
            } else {
                if (location.query['q'] || $el.data('events')) {
                    tabs.setTab($(':tabButtons').find('.-is-active'));
                } else {
                    tabs.setTab(tabs.$action[0]);
                }
            }

            $events.on(tabs.$action, 'click', (e, el) => {
                const event = $(el).data('event');

                tabs[event](el);
            });

            $events.on(tabs.$arrow, 'keyup', (e, el) => {
                if (e.key in map && tabs.$openTab) {
                    tabs[map[e.key]](el, true);
                }
            });
        });
    }
});
